import { useCompany, useCompanyCanonicalUrl } from '@/hooks/useCompany';
import type Company from '@simplywallst/services/lib/endpoints/types/company/Company';
import { useSection } from '../useSection';

function getDividendYield(company?: Company) {
  return company?.analysis?.data.extended.data.analysis.dividend.dividend_yield;
}

function useShouldNoIndexFollow() {
  const { currentSection } = useSection();
  const canonicalUrl = useCompanyCanonicalUrl();
  const company = useCompany(canonicalUrl);
  const dividendYield = getDividendYield(company.data?.data);

  //Only if dividend yield is 0 / null
  if (
    (dividendYield === 0 || dividendYield === null) &&
    currentSection === 'dividend'
  )
    return true;
  return false;
}
export default useShouldNoIndexFollow;
